<div class="modal-header">
    <h4 class="modal-title">Sign in required</h4>
</div>
<div class="modal-body">Please sign in before continuing.</div>
<div class="modal-footer">
    <div>
        <button
            type="button"
            class="btn btn-primary"
            (click)="okayClick()"
        >
            Proceed to sign in
        </button>
    </div>
</div>
